import {Store, Module, ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Organization from '../entities/organization'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface OrganizationState extends ListState<Organization> {
    editOrganization: Organization;
    permissions: Array<string>
}

class OrganizationModule extends ListModule<OrganizationState, any, Organization> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Organization>(),
        loading: false,
        editOrganization: new Organization(),
        permissions: new Array<string>()
    }
    actions = {
        async getAll(context: ActionContext<OrganizationState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/Organizations/GetAll', {params: payload.data});
            context.state.loading = false;
            let page = response.data.result as PageResult<Organization>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<OrganizationState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/services/app/Organizations/Create', payload.data);
            context.state.loading = false;
        },
        async update(context: ActionContext<OrganizationState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.put('/api/services/app/Organizations/Update', payload.data);
            context.state.loading = false;
        },
        async delete(context: ActionContext<OrganizationState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.delete('/api/services/app/Organizations/Delete?Id=' + payload.data.id);
            context.state.loading = false;
        },
        async get(context: ActionContext<OrganizationState, any>, payload: any) {
            let response = await Ajax.get('/api/services/app/Organizations/Get?Id=' + payload.id);
            return response.data.result as Organization;
        },
        async getAllPermissions(context: ActionContext<OrganizationState, any>) {
            let response = await Ajax.get('/api/services/app/Organizations/getAllPermissions');
            context.state.permissions = response.data.result.items;
        }
    };
    mutations = {
        setCurrentPage(state: OrganizationState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OrganizationState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: OrganizationState, organization: Organization) {
            state.editOrganization = organization;
        }
    }
}

const organizationModule = new OrganizationModule();
export default organizationModule;